import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

const constants = new Constants();
const httpService = new HttpService();

export const invitationService = {
  getCSRFAuthToken: async () => {
    try {
      return await fetch(
        constants.invitationServicesURLs.getCSRFToken,
        {
          credentials: "include"
        }
      );
    } catch (e) {
      throw e;
    }
  },

  getInvitationByToken: async (invitationToken) => {
    let options = {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    };
    return await fetch(
      constants.invitationServicesURLs.getInvitationByToken +
      `?token=${invitationToken}`,
      options
    );
  },

  cancelInvitation: async (session_id, data) => {
    try {
      return await httpService.postJson(
        constants.invitationServicesURLs.cancelInvitation,
        data,
        session_id
      );
    } catch (e) {
      throw e;
    }
  },
  resendInvitation: async (session_id, userId) => {
    try {
      return await httpService.postJson(
        constants.invitationServicesURLs.resendInvitation,
        {
          userId: userId,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  },

  getPaginatedInvitationsByAccount: async (session_id, page, size, status) => {
    try {
      let url =
        constants.invitationServicesURLs.getPaginatedInvitationsByAccount +
        `/page/${page}` +
        `/size/${size}`;

      // Only add status query param if it has a value
      if (status) {
        url += `?status=${status}`;
      }
      return await httpService.getJson(url, session_id);
    } catch (e) {
      throw e;
    }
  },
  acceptInvitation: async (authToken, invitationToken) => {
    try {
      const options = {
        method: 'POST',
        headers: {
          'X-XSRF-TOKEN': authToken,
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          'token': invitationToken
        })
      };
      const response = await fetch(constants.invitationServicesURLs.accpetInvitation, options);
      const data = await response.json();
      return data;
    } catch (e) {
      throw e;
    }
  },
  rejectInvitation: async (authToken, invitationToken) => {
    try {
      const options = {
        method: 'POST',
        headers: {
          'X-XSRF-TOKEN': authToken,
          'content-type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          'token': invitationToken
        })
      };
      const response = await fetch(constants.invitationServicesURLs.rejectInvitation, options);
      const data = await response.json();
      return data;
    } catch (e) {
      throw e;
    }
  },
};
